import moment from 'moment';
import { minDate } from './minDate';
import { germanDateFormat } from '@/utilities/germanFormats';

export const minDateNow = minDate(moment().format(germanDateFormat));
